import log from "loglevel";
import { ENV } from "@/config/env";

const LOG_LEVEL = {
  TRACE: "trace",
  INFO: "info",
  WARN: "warn",
  ERROR: "error",
  SILENT: "silent",
} as const;

type LogLevelKey = keyof typeof LOG_LEVEL;

const currentEnv = ENV.MODE === "development" ? ENV.MODE : ENV.APP_ENV;

if (currentEnv === "production") {
  log.setLevel(LOG_LEVEL.TRACE);
} else {
  log.setLevel(LOG_LEVEL.TRACE);
}

export const logger = {
  error: log.error.bind(console),
  warn: log.warn.bind(console),
  info: currentEnv !== "production" ? log.info.bind(console) : () => {},
  debug: currentEnv !== "production" ? log.debug.bind(console) : () => {},
  trace: currentEnv !== "production" ? log.trace.bind(console) : () => {},
};

export const setLogLevel = (level: string): void => {
  const levelKey = level.toUpperCase() as LogLevelKey;

  if (LOG_LEVEL[levelKey]) {
    log.setLevel(LOG_LEVEL[levelKey]);
  }
};
